module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "optinDialog",
    attrs: {
      "id": "channel-details-dialog",
      "title": _vm.dialogTitle,
      "top": "30vh",
      "width": "50rem",
      "show-close": true,
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "visible": _vm.showDialog,
      "destroy-on-close": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "channel-details"
  }, [_c('label', {
    staticClass: "form-label text-primary",
    attrs: {
      "for": "channelName"
    }
  }, [_vm._v("Channel Name:")]), _vm._v(" "), _c('div', {
    staticClass: "channel-item"
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    staticStyle: {
      "font-size": "30px"
    },
    attrs: {
      "type": _vm.channel.channel
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.channel.channel))])], 1), _vm._v(" "), _c('div', [_c('p', [_c('strong', [_vm._v("Opt In:")]), _c('i', {
    class: _vm.getIconClass(_vm.channel.opt_in)
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Opt Out:")]), _vm._v(" "), _c('i', {
    class: _vm.getIconClass(_vm.channel.opt_out)
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Permission to Process:")]), _vm._v(" "), _c('i', {
    class: _vm.getIconClass(_vm.channel.permission)
  })])]), _vm._v(" "), (_vm.channel.date_opted_in) ? _c('p', {
    staticClass: "date-opted-in"
  }, [_c('strong', [_vm._v("Date Opted In:")]), _vm._v(" " + _vm._s(_vm.formatDateOptedIn(_vm.channel.date_opted_in)) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361d3d3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/profile/dialogs/ChannelOptinDialog.vue
// module id = 3216
// module chunks = 3